import axios from '../axiosConfig'; // Assuming this is your configured Axios instance

import { API_BASE_URL } from '../config';
const baseURL = API_BASE_URL;

const addProductImage = async (data) => {
    var headers = {"Content-Type": "multipart/form-data" , 'Accept': 'application/json'};
    if (! axios.defaults.headers.common["Authorization"]){
      headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
    }
  
    try {
      const response = await axios.post('/file/upload/product/image', data, {
        headers: headers
      });
      console.log('response from backend', response);
      return response.data;
    } catch (error) {
      console.error('Error posting product main image:', error);
    }
  };

  const addProductImageList = async (data) => {
    var headers = {"Content-Type": "multipart/form-data" , 'Accept': 'application/json'};
    if (! axios.defaults.headers.common["Authorization"]){
      headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
    }
  
    try {
      const response = await axios.post('/file/upload/product/image/list', data, {
        headers: headers
      });
      console.log('response from backend', response);
      return response.data;
    } catch (error) {
      console.error('Error posting product image list:', error);
    }
  };

  const addProfileImage = async (data) => {
    var headers = {"Content-Type": "multipart/form-data" , 'Accept': 'application/json'};
    if (! axios.defaults.headers.common["Authorization"]){
      headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
    }
  
    try {
      const response = await axios.post('/file/upload/profile/image', data, {
        headers: headers
      });
      console.log('Response from backend', response);
      return response.data;
    } catch (error) {
      console.error('Error posting profile image:', error);
    }
  };
  const addEventImage = async (data) => {
    var headers = {"Content-Type": "multipart/form-data" , 'Accept': 'application/json'};
    if (! axios.defaults.headers.common["Authorization"]){
      headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
    }
  
    try {
      const response = await axios.post('/file/upload/event/image', data, {
        headers: headers
      });
      console.log('response from backend', response);
      return response.data;
    } catch (error) {
      console.error('Error posting product main image:', error);
    }
  };

  const addCompanyLogo = async (formData) => {
    var headers = {"Content-Type": "multipart/form-data" , 'Accept': 'application/json'};
    if (! axios.defaults.headers.common["Authorization"]){
      headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
    }
  
    try {
      const response = await axios.post('/file/upload/oem/image', formData, {
        headers: {'Content-Type': 'multipart/form-data'}
      });
      console.log('response from backend', response);
      return response.data;
    } catch (error) {
      console.error('Error posting product main image:', error);
    }
     
  };
   
  const addEmployeeProfileImage = async (data) => {
    var headers = {"Content-Type": "multipart/form-data" , 'Accept': 'application/json'};
    if (! axios.defaults.headers.common["Authorization"]){
      headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
    }
  
    try {
      const response = await axios.post('/file/upload/profile/image', data, {
        headers: headers
      });
      console.log('Response from backend', response);
      return response.data;
    } catch (error) {
      console.error('Error posting profile image:', error);
    }
  };
export { baseURL, addProductImage, addProductImageList,addEmployeeProfileImage, addProfileImage,addEventImage,addCompanyLogo};